import classnames from 'classnames'
import EmojiPicker from 'components/EmojiPicker'
import useIsMobile from 'hooks/useIsMobile'
import { ReactComponent as EmojiIcon } from 'images/emoji.svg'
import React, { useRef, useState } from 'react'

import NakedButton from '../NakedButton'

import './style.css'

interface TextAreaProps {
  // Overrides HTMLTextArea value to only accept string
  value: string,
  onValueChange?: (value: string) => void
}

type HTMLTextAreaProps = React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>

const TextArea = ({ value, onValueChange, ...textareaProps }: HTMLTextAreaProps & TextAreaProps) => {
  const isMobile = useIsMobile(true)
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(false)
  const emojiButtonRef = useRef(null)
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const onEmojiPickerClickOutside = (event) => {
    if (emojiButtonRef.current && emojiButtonRef.current.contains(event.target)) {
      return
    }
    setEmojiPickerOpen(false)
  }

  const onAddEmoji = (emoji: string) => {
    setEmojiPickerOpen(!emojiPickerOpen)
    if (!textareaProps.disabled) {
      onValueChange && onValueChange(emoji)
      textareaRef.current && textareaRef.current.focus()
    }
  }

  const onEmojiButtonClick = () => {
    if (textareaProps.disabled) {
      return
    }
    setEmojiPickerOpen(!emojiPickerOpen)
  }

  const onTextAreaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onValueChange && onValueChange(event.target.value)
    textareaProps.onChange && textareaProps.onChange(event)
  }

  return (
    <>
      {!isMobile &&
        <EmojiPicker
          open={emojiPickerOpen}
          onAddEmoji={onAddEmoji}
          onClickOutside={onEmojiPickerClickOutside}
        />
      }
      <div className="drift-widget-textarea">
        <pre>{value && !!value.length ? value : ' '}</pre>
        <textarea
          {...textareaProps}
          className={classnames('drift-widget-input', textareaProps.className)}
          value={value}
          ref={textareaRef}
          onChange={onTextAreaChange}
          disabled={textareaProps.disabled}
        />
        {!textareaProps.disabled && !isMobile &&
          <NakedButton
            ref={emojiButtonRef}
            className="drift-widget-textarea--emoji-toggle"
            onClick={onEmojiButtonClick}
            disabled={textareaProps.disabled}
            aria-expanded={emojiPickerOpen}
            aria-label="emojis"
          >
            <EmojiIcon />
          </NakedButton>
        }
      </div>
    </>
  )
}

export default TextArea
